import { createAction, props } from '@ngrx/store';

import { FeatureToggle } from './feature.state';

export const updateFeatureToggles = createAction('[Feauture Toggles] Update', props<{ toggles: FeatureToggle[] }>());
